import React from "react";

export default function Mission3(props) {
  return (
    <>
      <h2 className="mission-3">Mission 3: Send us the URL of your work</h2>
      <h3 id="description-2">Description</h3>
      <p>Make a POST request to the following URL.</p>
      <pre>
        <code>
          https://dps-challenge.netlify.app/.netlify/functions/api/challenge
        </code>
      </pre>
      <h4>Body</h4>
      <p> The body of the request should be JSON format, like below:</p>
      <pre>
        <code className="code json">
          {"{"}
          <br />
          <span className="code-attr">"github"</span>:
          <span className="code-string">"https://github.com/ACCOUNT/REPO"</span>
          ,
          <br />
          <span className="code-attr">"email"</span>:
          <span className="code-string">"EMAIL"</span>,<br />
          <span className="code-attr">"url"</span>:
          <span className="code-string">"DEPLOYED_ENDPOINT"</span>, <br />
          <span className="code-attr">"notes"</span>:
          <span className="code-string">"NOTES" // Not mandatory</span>
          <br />
          {"}"}
        </code>
      </pre>
      <p>
        Fill in your email address for <code>EMAIL</code>, the path to your
        github repo at <code>ACCOUNT/REPO</code> and the link of your deployed
        model at <code>DEPLOYED_ENDPOINT</code>. <br />
        <br /> At <code>NOTES</code>, {props.notes} <br />
        <br />
        Double-check that your email address is the same with the one you used
        at the application form.
      </p>
      <h4>Content type</h4>
      <p>
        The <code>Content-Type</code> of the request must be{" "}
        <code>application/json</code>.
      </p>
    
      <h4>Sample Request</h4>
      <pre>
        <code className="code http">
          <span className="code-keyword">POST</span>{" "}
          <span className="code-string">
            https://dps-challenge.netlify.app/.netlify/functions/api/challenge
          </span>
          <br />
          <span className="code-string">Content-Type</span>: application/json{" "}
          <br />
          <br />
          <span className="json">
            <>
              {"{"}
              <br />
              <span className="code-attr">"github"</span>:
              <span className="code-string">
                "https://github.com/DigitalProductschool/website"
              </span>
              ,<br />
              <span className="code-attr">"email"</span>:
              <span className="code-string">"name@example.com"</span>,<br />
              <span className="code-attr">"url"</span>:
              <span className="code-string">
                "https://digitalproductschool.io/", <br />
                <span className="code-attr">"notes"</span>:
                <span className="code-string">
                  "I deployed using ..." // Not mandatory
                </span>
              </span>
              <br />
              {"}"}
            </>
          </span>
        </code>
      </pre>
      <h4>Sample Response</h4>
      <p>
        If your POST request succeeds, the server returns HTTP status code{" "}
        <code>200</code>.
      </p>
      <pre>
        <code className="code http">
          Status <span className="code-number">200</span> OK <br />
          <span className="json">
            {"{"}
            <span className="code-attr">"message"</span>:
            <span className="code-string">
              "Congratulations! Achieved Mission 3"
            </span>
            {"}"}
          </span>
        </code>
      </pre>
    </>
  );
}
